import { useQuery } from '@tanstack/react-query'
import { rankingKeys } from '@!/Api/queryKeys'
import { getRankingApi } from '@!/Api/ranking'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useRanking = (rankingType, page, perPage) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  return useQuery({
    queryKey: rankingKeys.filtered(safeSearch, rankingType, page, perPage),
    queryFn: async () => {
      return await getRankingApi(safeSearch, rankingType, page, perPage)
    },
    keepPreviousData: true,
  })
}
